import { defaultFiltersObject } from "./helpers.js"
import { extractCommonMutations, extractInitialItemMutations } from "../../../shared"

export default () => ({
  ...extractCommonMutations(),
  ...extractInitialItemMutations(),

  RESET_FILTERS: state => (state.filters = defaultFiltersObject())
})
